import { Fragment, useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
// import PropTypes from "prop-types";
// import cx from "classnames";
import SortableList, { SortableItem } from "react-easy-sort";
import arrayMove from "array-move";
import { ReactTable } from "components/Table";
import { ModalChangeText, ModalTemplate, ModalAddImages } from "../modal";
import { countString, formatterCreateAt } from "components/Function";
import { createProductsByTemplate } from "actions/productActions";
import { changeTitleByAI } from "actions/aiActions";
import { CSVLink } from "react-csv";
import ReactImageMagnify from 'react-image-magnify';
import Loading from "components/Loading";

function Main({ createProductsByTemplate, user, countString, formatterCreateAt, changeTitleByAI, ai }) {
    const [isLoadingExport, setIsLoadingExport] = useState(false);
    const [isLoadingImport, setIsLoadingImport] = useState(false);
    const [page, setPage] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(10);
    const { t } = useTranslation();
    const [list, setList] = useState(localStorage.getItem("extension_listamazon") ? JSON.parse(localStorage.getItem("extension_listamazon")) : []);
    const [products_selected, setProductsSelected] = useState([]);
    const [products_selected_export, setProductsSelectedExport] = useState([]);
    const [initiateDownload, setInitiateDownload] = useState(false);
    const btnRef = useRef(null);
    var { expired_at } = user.user;
    var { isLoading } = ai;

    useEffect(() => {
        localStorage.setItem("extension_listamazon", JSON.stringify(list));

        var extension_settings = JSON.parse(localStorage.getItem("extension_settings"));
        if (typeof extension_settings?.["general"]?.crawl_tab === "undefined" || extension_settings?.["general"]?.crawl_tab === "0") {
            var list_tmp = JSON.parse(localStorage.getItem("extension_drop_list_amazon"));
            if (list_tmp) {
                localStorage.setItem("extension_drop_list_amazon", JSON.stringify(list_tmp?.filter((v2, i2) => list?.some((v1, i1) => v1.product_id === v2.product_id))));
            }
        }
    }, [list]);
    
    useEffect(() => {
        const handleLocalStorageFromExtension = () => {
            setList(JSON.parse(localStorage.getItem("extension_listamazon")));
        };

        window.addEventListener("updateLocalStorageFromExtension", handleLocalStorageFromExtension);
    
        return () => {
            window.removeEventListener("updateLocalStorageFromExtension", handleLocalStorageFromExtension);
        };
    }, []);

    useEffect(() => {
        setInitiateDownload(false);
        if (initiateDownload) {
            btnRef.current?.click();
        }
    }, [initiateDownload]);

    const onClickExport = () => {
        setIsLoadingExport(true);
        var products_selected_export = [];
        products_selected_export = list
            ?.filter((v, i) => products_selected?.includes(v.product_id))
            ?.map((v, i) => {
                return { product_id: "'" + v.product_id, title: v.title, images: v.images.join() };
            });
        setProductsSelectedExport(products_selected_export);
        setInitiateDownload(true);
        setIsLoadingExport(false);
    };

    const columns = [
        {
            dataField: "_id",
            text: "",
            sort: true,
            editable: false,
            formatter: (cell, row, rowIndex) => rowIndex + 1,
        },
        {
            dataField: "shop_name",
            text: t("Shop Name"),
            sort: true,
            editable: false,
        },
        {
            dataField: "product_id",
            text: t("Product ID"),
            sort: true,
            editable: false,
            formatter: (cell, row, rowIndex) => <Fragment><Link to={row?.product_link || "#"} target={row?.product_link ? "_blank" : "_self"}>{cell}</Link></Fragment>,
        },
        {
            dataField: "title",
            text: t("Title"),
            sort: true,
            classes: "al-cursor-pointer",
            headerStyle: { minWidth: "500px" },
            formatter: (cell, row, rowIndex) => (
                <Fragment>
                    <div>
                        <span className={cell?.length < 140 && cell?.length > 40 ? "text-success" : "text-danger"}>
                            Total Title: {cell?.length} <span className="text-info">{countString(cell)}</span>
                        </span>
                    </div>
                    {cell} <i className="fa fa-pencil"></i>
                </Fragment>
            ),
        },
        {
            dataField: "images",
            text: t("Images"),
            sort: true,
            editable: false,
            formatter: (cell, row, rowIndex) => (
                <Fragment>
                    <div>
                        <span className="text-success">
                            Total Images: {cell?.length}
                        </span>
                    </div>
                    <SortableList
                        onSortEnd={(oldIndex, newIndex) => onSortEnd(oldIndex, newIndex, rowIndex)}
                        className="al-thumbsContainer"
                        draggedItemClassName="dragged"
                    >
                        {cell?.map((v, i) => {
                            return (
                                <SortableItem key={i}>
                                    <div className="al-thumb">
                                        <div className="al-thumbInner position-relative">
                                            <button
                                                onClick={() => removeImageProduct(row.product_id, i)}
                                                type="button"
                                                className="btn-delete-image"
                                                style={{ zIndex: 9 }}
                                            >
                                                <i className="fa fa-trash"></i>
                                            </button>
                                            <ReactImageMagnify {...{ imageStyle: { objectFit: "cover" }, imageClassName: "al-product-img al-cursor-move w-100 h-100", smallImage: { alt: "", src: v || require("components/assets/media/misc/image.png"), width: 90, height: 90 }, largeImage: { src: v || require("components/assets/media/misc/image.png"), width: 300, height: 300 }, enlargedImageContainerDimensions: { width: '300%', height: '300%' }, enlargedImageContainerStyle: { "zIndex": 99 } }} />
                                        </div>
                                    </div>
                                </SortableItem>
                            );
                        })}
                    </SortableList>
                </Fragment>
            ),
        },
        {
            dataField: "note",
            text: t("Note"),
            sort: true,
            formatter: (cell, row, rowIndex) => <Fragment>{cell}</Fragment>,
        },
        {
            dataField: "-",
            text: t("Actions"),
            editable: false,
            formatter: (cell, row, rowIndex) => (
                <>
                    <ModalAddImages onSubmit={handleAddImages} product_id={row.product_id} />
                    <button
                        className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm"
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content={t("Delete")}
                        onClick={() => deleteProduct(row.product_id)}
                    >
                        <i className="ki-outline ki-trash fs-2"></i>
                    </button>
                </>
            ),
        },
    ];

    const onSortEnd = (oldIndex, newIndex, itemIndex) => {
        setList((prev) => {
            prev[itemIndex].images = arrayMove(prev[itemIndex]?.images || [], oldIndex, newIndex);
            return [...prev];
        });
    };

    const removeImageProduct = (productId, imageRemove) => {
        setList((prev) => {
            prev = prev.map((product) => {
                if (product.product_id === productId) {
                    const images = (product?.images || []).filter((_image, key) => key !== imageRemove);
                    return { ...product, images };
                }
                return { ...product };
            });

            return [...prev];
        });
    };

    const deleteProduct = (product_id) => {
        setList((prev) => [...prev?.filter((v, i) => v.product_id !== product_id)]);
    };

    const deleteProducts = () => {
        setList((prev) => [...prev?.filter((v) => !products_selected.includes(v.product_id))]);
        setProductsSelected([]);
    };

    const removeSelect = (arr, value) => {
        var i = 0;
        while (i < arr.length) {
            if (arr[i] === value) {
                arr.splice(i, 1);
            } else {
                ++i;
            }
        }
        return arr;
    };

    const onSelect = (row, isSelect) => {
        var products_selected_tmp = products_selected;
        if (isSelect) {
            products_selected_tmp.push(row.product_id);
        } else {
            products_selected_tmp = removeSelect(products_selected_tmp, row.product_id);
        }
        var new_arr = JSON.stringify(products_selected_tmp);
        setProductsSelected(JSON.parse(new_arr));
    };

    const onSelectAll = (isSelect, rows) => {
        var products_selected_tmp = products_selected;
        if (isSelect) {
            products_selected_tmp = rows.map(row => row.product_id);
        } else {
            products_selected_tmp = [];
        }
        setProductsSelected(products_selected_tmp);
    };

    const selectRow = {
        mode: "checkbox",
        clickToSelect: false,
        selected: products_selected,
        onSelect: onSelect,
        onSelectAll: onSelectAll,
        selectionHeaderRenderer: ({ indeterminate, checked, onChange }) => (
            <div className="d-flex">
                <input
                    type="checkbox"
                    ref={(input) => {
                        if (input) {
                            input.indeterminate = indeterminate;
                            input.checked = checked;
                        }
                    }}
                    onChange={onChange}
                />
                <span style={{ marginLeft: '8px' }}>({products_selected.length})</span>
            </div>
        ),
    };

    const groupButton = () => {
        return (
            <div className="mb-5">
                {expired_at - Date.now() >= 0 ? (
                    <Fragment>
                        <ModalChangeText onSubmit={handleChangeText} />
                        <button onClick={() => { onClickChangeTitleByAI() }} className="btn btn-info btn-sm me-1" disabled={products_selected.length <= 0} >
                            <img src={require("components/assets/media/custom/stars-ai-white.svg").default} style={{ "marginTop": "-3px", "marginRight": "5px" }} alt="" />
                            {t("AI Title Optimization")}
                        </button>
                        <ModalTemplate onSubmit={uploadProduct} />
                        <button
                            onClick={onClickExport}
                            className="btn btn-success btn-sm me-1"
                            disabled={products_selected.length <= 0}
                        >
                            <i className="ki-outline ki-exit-down"></i>
                            {t("Export")}
                        </button>
                        <CSVLink
                            className="d-none"
                            filename={"amazon_" + formatterCreateAt(new Date().getTime(), "dmy") + ".csv"}
                            data={products_selected_export}
                        >
                            <span ref={btnRef} />
                        </CSVLink>
                    </Fragment>
                ) : (
                    ""
                )}
                <button
                    onClick={deleteProducts}
                    type="button"
                    className="btn btn-danger btn-sm me-1"
                    disabled={products_selected.length <= 0}
                >
                    {t("Delete Products")}
                </button>
            </div>
        );
    };

    const handleTableChange = (type, { page, sizePerPage, searchText }) => {
        if (type === "search") {
            setPage(1);
            setSizePerPage(50);
        } else {
            setPage(page);
            setSizePerPage(sizePerPage);
        }
    };

    const handleChangeText = (data) => {
        setList((prev) => {
            prev = prev.map((item) => {
                if (!products_selected.includes(item.product_id)) return item;
                let title = item?.title;
                if (data?.textNew && data?.textOld) {
                    title = title?.replace(new RegExp(data?.textOld, "gi"), data?.textNew || "");
                }

                if (data?.textStart) title = `${data?.textStart} ${title}`;
                if (data?.textEnd) title = `${title} ${data?.textEnd}`;

                return { ...item, title };
            });
            return prev;
        });
    };

    const handleAddImages = (product_id, data) => {
        setList((prev) => {
            prev = prev.map((item, i) => {
                if (item.product_id !== product_id) return item;
                let images = item?.images;
                if (data.length > 0) {
                    images = [...images, ...data];
                }

                return { ...item, images };
            });
            return prev;
        });
    };

    const uploadProduct = ({ templateId, categoryId, otherImage, numberImage, removePrdImport, currency, categories }) => {
        var extension_settings = localStorage.getItem("extension_settings") ? JSON.parse(localStorage.getItem("extension_settings")) : {};
        createProductsByTemplate({
            templateId,
            categoryId,
            categories,
            currency,
            data: list.reduce((result, item) => {
                if (products_selected.includes(item.product_id)) {
                    const itemAdd = { ...item, main_images: item.images.slice(0, numberImage), product_sku: item?.product_sku || item.product_id, };
                    if (otherImage?.length) itemAdd.main_images = [...(itemAdd.main_images || []), ...otherImage];
                    result.push(itemAdd);
                }
                return result;
            }, []),
            setIsLoadingImport,
            filterProduct: +extension_settings?.general?.filter_duplicate_products || 0
        }).then((r) => {
            if (removePrdImport && r) {
                setList((prev) => prev.filter((item) => !products_selected.includes(item.product_id)));
                setProductsSelected([]);
            }
        });
    };

    const handleTableSaveCell = (oldValue, newValue, row, column) => {
        row[column.dataField] = newValue;
        setList((prev) => {
            const data = prev.map((product) => {
                if (product.product_id === row.product_id) {
                    product[column.dataField] = newValue;
                }
                return product;
            });
            return [...data];
        });
    };

    const onClickChangeTitleByAI = () => {
        var arr_product = [];
        products_selected.forEach((v, i) => {
            var product_find = list.find((v2, i2) => v2?.product_id === v);
            if (product_find) {
                arr_product.push({ [product_find?.product_id]: product_find?.title });
            }
        });
        changeTitleByAI(arr_product, setList);
    };

    const sizePerPageList = [
        {
            text: "10",
            value: 10,
        },
        {
            text: "20",
            value: 20,
        },
        {
            text: "30",
            value: 30,
        },
        {
            text: "40",
            value: 40,
        },
        {
            text: "50",
            value: 50,
        },
        {
            text: "All",
            value: list.length || 10,
        },
    ];

    return (
        <Fragment>
            <Loading isLoading={isLoading || isLoadingExport || isLoadingImport} />
            <ReactTable
                keyField="product_id"
                columns={columns}
                data={list}
                groupButton={groupButton}
                handleTableChange={handleTableChange}
                page={page}
                sizePerPage={sizePerPage}
                totalSize={list.length}
                alClassName="table-layout-inherit"
                remote={{ search: false, pagination: false, sort: false }}
                isSelectRow={true}
                selectRow={selectRow}
                isCellEdit={true}
                handleBeforeSaveCell={handleTableSaveCell}
                sizePerPageList={sizePerPageList}
            />
        </Fragment>
    );
}

const mapStateToProps = (state) => ({
    user: state.user,
    ai: state.ai
});
const mapDispatchToProps = { createProductsByTemplate, countString, formatterCreateAt, changeTitleByAI };

export default connect(mapStateToProps, mapDispatchToProps)(Main);
